import { Update } from '@mui/icons-material';
import { Box } from '@mui/material';
import { CustomLoadingButton } from 'components/Buttons/CustomLoadingButton/CustomLoadingButton';
import dayjs from 'dayjs';
import { useAppDispatch, useAppSelector } from 'store/hook';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import useCustomerInfo from 'hooks/useCustomerInfo';
import { useNavigate } from 'react-router-dom';
import { resetPlan, setAssetLevelInput } from 'store/fleet-planning.slice';
import useShiftConfig from 'hooks/useShiftConfig';
import { mergeDispatchPlans } from '../utils/dataFormatters';

dayjs.extend(utc);
dayjs.extend(timezone);

export const ReSchedule = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { customerTz } = useCustomerInfo();
  const { shiftOptions } = useShiftConfig();

  const assetsData = useAppSelector((state) => state.assetReducer.assets);
  const approvedPlanData = useAppSelector(
    (state) => state.fleetPlanningReducer.dispatchPlanSummary
  );

  const handleReschedulePlan = () => {
    if (Array.isArray(assetsData)) {
      const currentTimeInCustomerTz = dayjs().tz(customerTz);

      const updatedAssetLvlInput = assetsData
        .filter((el) => el?.assetType === 'haul_truck')
        .map((el) => {
          const shift = shiftOptions[0];
          const startHour = shift.startHour;
          const endHour = shift.endHour;

          // Base date in customer timezone. Use add() so fractional shift
          // hours (e.g. 7.5 -> 07:30) are preserved instead of truncated.
          const baseDate = dayjs().tz(customerTz).startOf('day');
          const startTimeLocal = baseDate.add(startHour, 'hour');
          const endTimeLocal = baseDate.add(endHour, 'hour');

          // Default lunch to middle of shift
          const shiftDuration = endTimeLocal.diff(startTimeLocal, 'minutes');
          const lunchStartLocal = startTimeLocal.add(
            shiftDuration / 2,
            'minutes'
          );
          const lunchEndLocal = lunchStartLocal.add(60, 'minutes');

          // only override start time if current time < end time
          const startTime = currentTimeInCustomerTz.isBefore(endTimeLocal)
            ? currentTimeInCustomerTz.toISOString()
            : startTimeLocal.toISOString();

          return {
            id: el?.assetId,
            name: el?.bumperNumber,
            startTime,
            endTime: endTimeLocal.toISOString(),
            capacity: '85',
            lunchStart: lunchStartLocal.toISOString(),
            lunchEnd: lunchEndLocal.toISOString(),
            lunchBreakMinutes: '60',
          };
        });

      dispatch(resetPlan('optimizedPlan'));
      dispatch(resetPlan('userPlan'));
      dispatch(setAssetLevelInput(updatedAssetLvlInput));
    }
    navigate('/fleet-planner/create-dispatch-plan');
  };

  const mergedPlans = mergeDispatchPlans(approvedPlanData.plans);

  const hasActiveSchedule =
    Array.isArray(mergedPlans.planData) &&
    mergedPlans?.planData?.length > 0 &&
    approvedPlanData.planType === 'single_active';

  return (
    <>
      {hasActiveSchedule ? (
        <Box>
          <CustomLoadingButton
            startIcon={<Update />}
            onClick={handleReschedulePlan}
            sx={{
              height: '32px',
            }}
          >
            Reschedule
          </CustomLoadingButton>
        </Box>
      ) : null}
    </>
  );
};
